/* Provencelia : fiche produit (28/09/2026)
   1. « Lire la suite » sur le résumé court (snippets/product-info, bloc text).
   2. Demande de retour en stock en ligne (snippets/pv-retour-stock), branchée sur l'app Stok.
   Chargé en type="module" depuis plusieurs snippets : le navigateur ne l'exécute qu'une fois. */

/* ---------- 1. Lire la suite ---------- */

const LIGNES = 3;

function hauteurDuTexte(boite) {
  const haut = boite.getBoundingClientRect().top;
  let bas = haut;
  const marcheur = document.createTreeWalker(boite, NodeFilter.SHOW_TEXT);
  const plage = document.createRange();
  while (marcheur.nextNode()) {
    const noeud = marcheur.currentNode;
    if (!noeud.textContent.trim()) continue;
    plage.selectNodeContents(noeud);
    bas = Math.max(bas, plage.getBoundingClientRect().bottom);
  }
  return bas - haut;
}

function initResume(racine) {
  racine.querySelectorAll('[data-pv-resume]').forEach((bloc) => {
    if (bloc.dataset.pvInit) return;
    bloc.dataset.pvInit = '1';

    const texte = bloc.querySelector('.pv-resume__texte');
    const lien = bloc.querySelector('.pv-resume__lien');
    if (!texte || !lien) return;

    const para = texte.querySelector('p') || texte;
    const style = getComputedStyle(para);
    const interligne = parseFloat(style.lineHeight) || parseFloat(style.fontSize) * 1.6;
    const hauteur = Math.ceil(interligne * LIGNES);

    // Texte déjà court : ni repli ni lien. On mesure le texte réellement écrit,
    // pas la boîte : le paragraphe vide ajouté après le metafield (<p></p>) et
    // les marges entre paragraphes faisaient croire à plus de 3 lignes.
    if (hauteurDuTexte(texte) <= hauteur + 4) return;

    const replier = () => {
      texte.style.maxHeight = hauteur + 'px';
      texte.classList.add('is-replie');
      lien.textContent = 'Lire la suite';
      lien.setAttribute('aria-expanded', 'false');
    };
    const deplier = () => {
      texte.style.maxHeight = 'none';
      texte.classList.remove('is-replie');
      lien.textContent = 'Réduire';
      lien.setAttribute('aria-expanded', 'true');
    };

    replier();
    lien.hidden = false;
    lien.addEventListener('click', () => {
      lien.getAttribute('aria-expanded') === 'true' ? replier() : deplier();
    });
  });
}

/* ---------- 2. Retour en stock (Stok) ---------- */

const STOK = {
  email: 'shopeetech-bis-popup-form-email',
  quantite: 'shopeetech-bis-popup-form-amount',
  envoyer: 'submit-btn__bis',
  succes: ['success_message', 'thank-you-section'],
  dejaInscrit: 'error_message',
  ouvrir: 'bis-myBtn',
  bouton: 'bis_notify_me_btn',
  fenetre: 'bis-myModal',
};

const $id = (id) => document.getElementById(id);
const visible = (el) => !!el && getComputedStyle(el).display !== 'none' && el.offsetParent !== null;
const affiche = (el) => !!el && getComputedStyle(el).display !== 'none';

function initAlerte() {
  const bloc = document.querySelector('[data-pv-alerte]');
  if (!bloc || bloc.dataset.pvInit) return;
  bloc.dataset.pvInit = '1';

  // Stok s'injecte après le chargement : on l'attend jusqu'à 10 s.
  let essais = 0;
  const attente = setInterval(() => {
    essais += 1;
    if ($id(STOK.email) && $id(STOK.envoyer)) {
      clearInterval(attente);
      brancher(bloc);
    } else if (essais > 40) {
      clearInterval(attente); // Stok absent : le bloc reste masqué.
    }
  }, 250);
}

function brancher(bloc) {
  const form = bloc.querySelector('form');
  const champ = bloc.querySelector('input[type=email]');
  const bouton = bloc.querySelector('button[type=submit]');
  const message = bloc.querySelector('.pv-alerte__message');
  const objet = bloc.dataset.objet || 'cet article';

  bloc.hidden = false;
  document.documentElement.classList.add('pv-alerte-active'); // masque le bouton Stok (CSS)

  // Resserrer l'espace au-dessus du bloc : les blocs d'app vides (hauteur nulle) qui le
  // précèdent gardent leurs marges et creusaient ~80 px sous « En rupture ».
  const item = bloc.closest('.product-info__block-item');
  if (item) {
    item.style.marginTop = '0';
    let prec = item.previousElementSibling;
    while (prec && prec.getBoundingClientRect().height === 0) {
      prec.style.margin = '0';
      prec = prec.previousElementSibling;
    }
    if (prec) prec.style.marginBottom = '16px';
  }

  const dire = (texte, erreur = false) => {
    message.textContent = texte;
    message.hidden = false;
    message.classList.toggle('is-erreur', erreur);
  };

  const fermerFenetreStok = () => {
    const f = $id(STOK.fenetre);
    if (!affiche(f)) return;
    const croix = f.querySelector('.close, [class*=close]');
    if (croix) croix.click();
    if (affiche(f)) f.style.display = 'none';
  };

  // Stok réclame une information de plus : on ouvre sa fenêtre, adresse remplie.
  const repli = (email) => {
    const ouvrir = $id(STOK.ouvrir);
    if (ouvrir) ouvrir.click();
    setTimeout(() => {
      const e = $id(STOK.email);
      if (e && !e.value) remplir(e, email);
    }, 300);
    dire('Merci de compléter votre demande dans la fenêtre qui vient de s’ouvrir.');
    bouton.disabled = false;
  };

  form.addEventListener('submit', (evt) => {
    evt.preventDefault();
    const email = champ.value.trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) {
      dire('Veuillez saisir une adresse e-mail valide.', true);
      champ.focus();
      return;
    }

    const eStok = $id(STOK.email);
    const qStok = $id(STOK.quantite);
    remplir(eStok, email);
    if (qStok && !qStok.value) remplir(qStok, '1');

    // On mémorise l'état avant l'envoi, pour ne lire que la réponse à CETTE demande.
    const avant = {
      succes: STOK.succes.some((id) => affiche($id(id))),
      erreur: affiche($id(STOK.dejaInscrit)),
    };

    bouton.disabled = true;
    message.hidden = true;
    $id(STOK.envoyer).click();

    let tours = 0;
    const suivi = setInterval(() => {
      tours += 1;
      const succes = STOK.succes.some((id) => affiche($id(id)));
      const deja = affiche($id(STOK.dejaInscrit));
      const avertissement = [...document.querySelectorAll('#' + STOK.fenetre + ' small[id^="shopeetech-bis-form-"]')]
        .some((s) => !s.classList.contains('shopeetech-bis-form-hide-warning') && visible(s));

      if (succes && !avant.succes) {
        clearInterval(suivi);
        fermerFenetreStok();
        form.hidden = true;
        dire(`C’est noté. Nous vous écrivons à ${email} dès que ${objet} est de nouveau disponible.`);
      } else if (deja && !avant.erreur) {
        clearInterval(suivi);
        fermerFenetreStok();
        form.hidden = true;
        dire(`Cette adresse est déjà inscrite pour ${objet}. Nous vous écrirons dès son retour.`);
      } else if (avertissement || tours > 40) {
        clearInterval(suivi);
        repli(email);
      }
    }, 250);
  });
}

function remplir(el, valeur) {
  if (!el) return;
  el.value = valeur;
  el.dispatchEvent(new Event('input', { bubbles: true }));
  el.dispatchEvent(new Event('change', { bubbles: true }));
}

/* ---------- Lancement ---------- */

const lancer = () => {
  // On mesure le résumé une fois les polices chargées : avant, la hauteur des lignes est fausse.
  const polices = document.fonts && document.fonts.ready ? document.fonts.ready : Promise.resolve();
  polices.then(() => initResume(document));
  initAlerte();
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', lancer);
} else {
  lancer();
}
